/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import { faChevronCircleLeft, faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import CustomIcon from 'commons/Icon/CustomIcon';
import { CustomLinkRouter } from 'commons/Link/CustomLink';
import LocalizedText from 'commons/LocalizedText/LocalizedText';
import { CustomTooltip } from 'commons/Tooltip/CustomTooltip';
import { useLaboratoryInfo } from 'hook/UseLaboratoryInfo';
import { useLaboratoryTestInfo } from 'hook/UseLaboratoryTestInfo';
import useMobile from 'hook/UseMobile';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { MOBILE_BREAKPOINT } from 'utils/constants/responsive';
import { getTabsByPage } from 'utils/constants/tabs';
import { QueryStringToJSONObject } from 'utils/helpers/QueryStringHelper';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(10),
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(1)
    }
  },
  nav: {
    display: 'inline-block'
  },
  backButton: {
    color: theme.palette.primary.main
  },
  currentPage: {
    color: theme.palette.secondary.main,
    fontSize: '130%',
    fontWeight: 'bold',
    [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
      fontSize: '110%'
    }
  },
  disabled: {
    color: theme.palette.text.disabled
  }
}));

export default function BreadCrumb() {
  const history = useHistory();
  const isMobile = useMobile();
  const classes = useStyles();
  const laboratoryInfo = useLaboratoryInfo();
  const productTestInfo = useLaboratoryTestInfo();
  const pathNames = window.location.pathname.split('/').filter(path => path !== 'labo');
  const [JSONQueryString, setJSONQueryString] = useState(QueryStringToJSONObject(window.location.search.substring(1)));
  const tabs = getTabsByPage(pathNames[3])();

  useEffect(() => {
    setJSONQueryString(QueryStringToJSONObject(window.location.search.substring(1)));
  }, [window.location.search])

  const fillLabo = path => {
    return (laboratoryInfo.name ? `${laboratoryInfo.name} (${laboratoryInfo?.companyNumber})` : path)
  }

  const fillProductTest = path => {
    return (productTestInfo?.ptldGeneralProjection?.eccTestNumber ? `${productTestInfo?.ptldGeneralProjection.eccTestNumber}` : path)
  }

  const displayComputeInfoByIndex = (path, index) => {
    switch (index) {
    case 1:
    case 4:
      return fillProductTest(path);
    case 2:
      return fillLabo(path);
    default:
      return null;
    }
  }

  const generateLinkTo = (path, index) => {
    const isLaboInUrl = window.location.pathname.split('/').includes('labo');
    let to = `${isLaboInUrl ? '/labo' : ''}${pathNames.slice(0, index + 1).join('/')}`;
    if(path === 'usersList'){
      const tabSelected = tabs.findIndex(tab => tab.LABEL === 'users');
      if(tabSelected !== -1){
        to = `${isLaboInUrl ? '/labo' : ''}${pathNames.slice(0, index).join('/')}?tabSelected=${tabSelected}`;
      }
    }
    return to;
  }

  return (
    <div className={classes.root}>
      <CustomTooltip title="goBackHistory">
        <IconButton className={classes.backButton} onClick={() => history.goBack()}>
          <CustomIcon icon={faChevronCircleLeft}/>
        </IconButton>
      </CustomTooltip>
      <Breadcrumbs aria-label="breadcrumb" className={classes.nav} separator={<CustomIcon icon={faChevronRight}/>}>
        {
          pathNames.map((path, index) => {
            const isLast = index === pathNames.length - 1;
            const isIdentifier = path.match(/^[0-9-]*$/);
            const isIdCrypted = path.match(/^[A-Z0-9]{154}$/);
            const isTrimmed = isMobile || path === 'laboratory';

            if (index === 0 || index === 1) return '';

            const to = generateLinkTo(path, index);

            if (isLast && !isIdCrypted) {
              if (path !== '') {
                return (
                  <LocalizedText className={classes.currentPage} key={to}>
                    {`${path}`}
                  </LocalizedText>
                );
              } else {
                return;
              }
            }else if(isLast && index === 5 && pathNames[index-1] === 'usersList'){
              return (
                <LocalizedText className={classes.currentPage}>
                  {`editUser`}
                </LocalizedText>
              )
            }
            if (isTrimmed) {
              return '';
            }

            const textToDisplay = isIdCrypted ? displayComputeInfoByIndex(path, index) :  isIdentifier ? path : `${path}`

            return (
              textToDisplay && (
                <CustomLinkRouter key={to} to={to} >
                  <LocalizedText>
                    {textToDisplay}
                  </LocalizedText>
                </CustomLinkRouter>
              )
            );
          })
        }
        {
          ((JSONQueryString.tabSelected !== null || JSONQueryString.tabSelected !== undefined) && tabs[JSONQueryString.tabSelected]) && (
            <LocalizedText className={classes.currentPage}>
              {`${tabs[JSONQueryString.tabSelected].LABEL}`}
            </LocalizedText>
          )
        }
      </Breadcrumbs>
    </div>
  );
};